module.exports = "/_next/static/images/wirelessCommunicationBg-3c94434bc8375569aa1751dcaee7914d.webp";